import { useFrontendTool } from '@copilotkit/react-core';
import { useNavigate } from 'react-router-dom';

import { useAPI } from 'hooks/api/useAPI';
import { useCreatePipeline } from 'pipelines/hooks/useCreatePipeline';

export function useCreatePipelineTool() {
  const { mutateAsync: createPipeline } = useCreatePipeline();
  const { applicationID } = useAPI();
  const navigate = useNavigate();

  useFrontendTool({
    name: 'createPipeline',
    description:
      'Create a new pipeline from the specified definition. ALWAYS use it after successfully generating a pipeline definition with the generate_pipeline_definition tool.',
    parameters: [
      {
        name: 'name',
        type: 'string',
        description: 'name of the pipeline to create',
        required: true,
      },
      {
        name: 'definition',
        type: 'string',
        description: 'JSON-encoded pipeline definition',
        required: true,
      },
    ],
    handler: async ({ name, definition }) => {
      const pipeline = await createPipeline({
        name,
        definition: JSON.parse(definition),
      });
      navigate(
        `/applications/${applicationID}/design/pipelines/${pipeline.id}`
      );
      return pipeline.id;
    },
  });
}
